import { Download } from 'lucide-react';
import { useDownloads } from '@/features/downloads/DownloadProvider';
import type { Sign } from '@/types/catalog';

interface Props {
  categoryId: string;
  signs: Sign[];
  offlineCount: number;
}

/**
 * Baixar uma categoria inteira (F8-T05, F12-T18).
 *
 * Some quando nenhum sinal da categoria tem origem de mídia — sem isso o botão
 * existiria só para não funcionar.
 */
export function CategoryDownloadButton({
  categoryId,
  signs,
  offlineCount,
}: Props): React.ReactElement | null {
  const { canDownload, queueCategory } = useDownloads();

  const downloadable = signs.filter((sign) => canDownload(sign));
  if (downloadable.length === 0) return null;

  const missing = downloadable.length - offlineCount;
  if (missing <= 0) {
    return (
      <p className="mt-3 rounded-xl bg-emerald-500/10 p-3 text-sm text-emerald-300">
        Todos os vídeos desta categoria estão disponíveis offline.
      </p>
    );
  }

  return (
    <button
      type="button"
      onClick={() => void queueCategory(categoryId)}
      className="mt-3 flex min-h-12 w-full items-center justify-center gap-2 rounded-xl bg-sky-500/15 text-sm font-medium text-sky-300 active:bg-sky-500/25"
    >
      <Download size={18} aria-hidden />
      Baixar {missing} {missing === 1 ? 'vídeo' : 'vídeos'}
    </button>
  );
}
